import { createApp } from 'vue';
import TeamSelector from './vue/team-selector.vue';
import { context } from './team-selector.config.yml';


const app = createApp(TeamSelector, context);
app.mount('#team-selector-root');
